export default __webpack_public_path__ + "static/media/sku-analysis-logo-blue.02b0c703.png";